import React from "react";
import { IconButton } from "@fluentui/react/lib/Button";
import {
  IContextualMenuProps,
  IContextualMenuItem,
  ContextualMenuItemType,
} from "@fluentui/react/lib/ContextualMenu";
import { useMemo } from "react";
import { IIconProps } from "@fluentui/react";

export interface ContextualMenuItem extends IContextualMenuItem {}

export enum ContextualMenuItemTypeEnum {
  Divider = ContextualMenuItemType.Divider,
  Section = ContextualMenuItemType.Section,
}

interface Props {
  menu: ContextualMenuItem[];
}

const MoreActionsButton = (props: Props) => {
  const menuProps = useMemo<IContextualMenuProps>(() => ({
    items: props.menu,
  }), [props.menu]);

  const addIcon: IIconProps = { iconName: "More" };

  return (
    <>
      <IconButton
        iconProps={addIcon}
        menuProps={menuProps}
        className="icon-button-contextual-menu"
      />
    </>
  );
};

export default MoreActionsButton;
